/* global window, document */
(function () {
  'use strict';

  var OPEN_DELAY = 350;

  function ProductPopup(root) {
    this.root = root;
    this.dialog = root.querySelector('.product-popup__dialog');
    this.lastFocused = null;

    this.onKeydown = this.onKeydown.bind(this);
    this.close = this.close.bind(this);

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-product-popup-close]'),
      function (el) {
        el.addEventListener('click', this.close);
      },
      this
    );
  }

  ProductPopup.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;

    this.lastFocused = document.activeElement;

    this.root.removeAttribute('hidden');
    document.body.classList.add('product-popup-open');
    document.addEventListener('keydown', this.onKeydown);

    // Let the browser paint the hidden->visible switch before transitioning in.
    window.requestAnimationFrame(
      function () {
        window.requestAnimationFrame(
          function () {
            this.root.classList.add('is-open');
          }.bind(this)
        );
      }.bind(this)
    );

    var closeBtn = this.root.querySelector('.product-popup__close');
    if (closeBtn) closeBtn.focus();
  };

  ProductPopup.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.root.classList.remove('is-open');
    document.body.classList.remove('product-popup-open');
    document.removeEventListener('keydown', this.onKeydown);

    var self = this;
    window.setTimeout(function () {
      self.root.setAttribute('hidden', '');
    }, 250);

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }
  };

  ProductPopup.prototype.onKeydown = function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.close();
    }
  };

  function init() {
    var root = document.querySelector('[data-product-popup]');
    if (!root || root._productPopup) return;

    var popup = new ProductPopup(root);
    root._productPopup = popup;

    window.setTimeout(function () {
      popup.open();
    }, OPEN_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
